// extracted by mini-css-extract-plugin
export default {"aiWriterDropdownPopup":"nlJcJB7MGUSM5E6XMytO","scrollableContent":"TBr087Fb3vdclJNO4q2n","skeletonContainer":"QjuAhrXhMbHTqU_dkY6t"};